import orderService from '../../../../services/OrderService';
import useDownload from '../../../hooks/useDownload';


/**
 * Downloads the order contents for the given order id.
 * Takes the given callbacks after the async download operation, if required.
 *
 * @return {(function(*, *=, *=): void)|*}
 */
function useDownloadOrderContents() {

    const download = useDownload();

    return (orderId, onComplete = () => {}, onError = () => {}) => {

        (async () => {

            const downloadOrderRequest = orderService.createOrderDownloadRequest(orderId);
            await download(downloadOrderRequest, onError);

            onComplete();
        })();
    };
}


export default useDownloadOrderContents;
